<template>
  <div class="page-heading flex-col">
    <h1 class="title">
      <b>{{ title || "------" }}</b>
      <InfoTooltip v-if="tooltip" :text="tooltip" />
    </h1>
    <p class="description" v-html="description || ' '"></p>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    description: String,
    tooltip: String,
  },
};
</script>

<style lang="scss" scoped>
.page-heading {
  .title {
    font-weight: bold;
  }

  .description {
    margin: 0;
    padding-top: 10px;
    opacity: 0.7;
  }
}
</style>
